var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 8H32V0H4C1.8 0 0 1.8 0 4V26H4C4 29.32 6.68 32 10 32C13.32 32 16 29.32 16 26H28C28 29.32 30.68 32 34 32C37.32 32 40 29.32 40 26H44V16L38 8ZM37 11L40.92 16H32V11H37ZM10 28C8.9 28 8 27.1 8 26C8 24.9 8.9 24 10 24C11.1 24 12 24.9 12 26C12 27.1 11.1 28 10 28ZM14.44 22C13.34 20.78 11.78 20 10 20C8.22 20 6.66 20.78 5.56 22H4V4H28V22H14.44ZM34 28C32.9 28 32 27.1 32 26C32 24.9 32.9 24 34 24C35.1 24 36 24.9 36 26C36 27.1 35.1 28 34 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.4670dfbae180556370d41739df7d2259.svg";
export { ForwardRef as ReactComponent };